import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Box, TextField } from 'seagull';
import { useOnMount } from "../../hooks/useOnMount";
import { jsx as _jsx } from "react/jsx-runtime";
const OTPVerificationField = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    length = 6,
    onChange,
    hasError = false,
    onInputChange
  } = _ref;
  const [values, setValues] = useState(Array(length).fill(''));
  const inputsRef = useRef([]);
  const [error, setError] = useState(hasError);
  useEffect(() => {
    if (hasError) {
      setError(true);
      inputsRef.current.forEach(input => {
        if (input) input.blur();
      });
    } else setError(false);
  }, [hasError]);
  useOnMount(() => {
    focusInput(0);
  });
  const focusInput = index => {
    const input = inputsRef.current[index];
    if (input) input.focus();
  };
  useImperativeHandle(ref, () => ({
    reset: () => {
      setValues(Array(length).fill(''));
      setError(false);
      focusInput(0);
    }
  }));
  const handleChange = (e, index) => {
    const val = e.target.value.replace(/[^0-9]/g, '');
    const newValues = [...values];
    newValues[index] = val[0] || '';
    setError(false);
    onInputChange === null || onInputChange === void 0 || onInputChange();
    setValues(newValues);
    const fullCode = newValues.join('');
    if (fullCode.length === length && !newValues.includes('')) {
      onChange === null || onChange === void 0 || onChange(fullCode);
    }
    if (val && index < length - 1) {
      focusInput(index + 1);
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !values[index] && index > 0) {
      const newValues = [...values];
      newValues[index - 1] = '';
      setError(false);
      setValues(newValues);
      focusInput(index - 1);
    }
  };
  const handlePaste = e => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/[^0-9]/g, '').slice(0, length).split('');
    const newValues = [...values];
    pasted.forEach((char, idx) => {
      if (idx < length) newValues[idx] = char;
    });
    setError(false);
    setValues(newValues);
    const fullCode = newValues.join('');
    if (fullCode.length === length && !newValues.includes('')) {
      onChange === null || onChange === void 0 || onChange(fullCode);
    }
    const nextIndex = pasted.length >= length ? length - 1 : pasted.length;
    focusInput(nextIndex);
  };
  return /*#__PURE__*/_jsx(Box, {
    display: "flex",
    gridGap: 10,
    justifyContent: "center",
    children: values.map((char, idx) => /*#__PURE__*/_jsx(TextField, {
      "data-testid": "otp-verification-field-".concat(idx),
      inputRef: el => inputsRef.current[idx] = el,
      value: char,
      onChange: e => handleChange(e, idx),
      onPaste: handlePaste,
      error: error,
      inputProps: {
        maxLength: 1,
        inputMode: 'numeric',
        pattern: '[0-9]*',
        onKeyDown: e => handleKeyDown(e, idx),
        style: {
          textAlign: 'center',
          fontSize: '1.5rem',
          padding: 0,
          width: '56px',
          height: '56px'
        }
      },
      style: {
        width: '55px'
      }
    }, idx))
  });
});
OTPVerificationField.displayName = 'OTPVerificationField';
export default OTPVerificationField;